import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import KerrvilleLogo from '../KerrvilleLogo';

export default function SharedNav() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/">
            <KerrvilleLogo />
          </Link>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-sm font-medium text-gray-700 hover:text-[#0077B6] transition-colors whitespace-nowrap cursor-pointer">
              Home
            </Link>
            <Link to="/private-health-insurance-kerrville-tx" className="text-sm font-medium text-gray-700 hover:text-[#0077B6] transition-colors whitespace-nowrap cursor-pointer">
              Private Insurance
            </Link>
            <Link to="/group-health-insurance-kerrville-tx" className="text-sm font-medium text-gray-700 hover:text-[#0077B6] transition-colors whitespace-nowrap cursor-pointer">
              Group Plans
            </Link>
            <Link to="/medicare-kerrville-tx" className="text-sm font-medium text-gray-700 hover:text-[#0077B6] transition-colors whitespace-nowrap cursor-pointer">
              Medicare
            </Link>
            <a
              href="tel:830-203-6201"
              className="px-5 py-2 bg-[#0077B6] text-white text-sm font-semibold rounded-full hover:bg-[#005F8C] transition-colors whitespace-nowrap cursor-pointer"
            >
              830-203-6201
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
